// extracted by mini-css-extract-plugin
export var box = "Footer-module--box--e44a8";
export var layout = "Footer-module--layout--bb888";
export var box_md = "Footer-module--box_md--5bc06";
export var box_xmd = "Footer-module--box_xmd--d7ce9";
export var box_flex = "Footer-module--box_flex--46a27";
export var box_lg = "Footer-module--box_lg--988f6";
export var box_sm = "Footer-module--box_sm--4d7ce";
export var box_outer = "Footer-module--box_outer--cf249";
export var box_whiteBg = "Footer-module--box_white-bg--3c56f";
export var box_noMarginBottom = "Footer-module--box_no-margin-bottom--def73";
export var box_noPadding = "Footer-module--box_no-padding--a1bdb";
export var box_outerGray = "Footer-module--box_outer-gray--5078e";
export var box_dark = "Footer-module--box_dark--bfe92";
export var box_zIndex = "Footer-module--box_z-index--ded84";
export var box_zIndex6 = "Footer-module--box_z-index-6--2bc93";
export var box_eventsWithLine = "Footer-module--box_events-with-line--1f6a4";
export var box_featuresAo = "Footer-module--box_features-ao--48d00";
export var box_verticalPaddings = "Footer-module--box_vertical-paddings--7c3bd";
export var clearP = "Footer-module--clearP--f2039";
export var clearP_vc = "Footer-module--clearP_vc--36b7c";
export var socialWrapper = "Footer-module--socialWrapper--8d0ff";
export var offices = "Footer-module--offices--1853b";
export var officeItem = "Footer-module--officeItem--a34fe";
export var officeTitle = "Footer-module--officeTitle--625f4";
export var officeDescription = "Footer-module--officeDescription--44551";
export var officeLink = "Footer-module--officeLink--2b7d3";
export var officeLinkWrapper = "Footer-module--officeLinkWrapper--939a8";
export var companyLinks = "Footer-module--companyLinks--d049d";
export var fadeInAnimation = "Footer-module--fadeInAnimation--2ac29";
export var placeHolderShimmer = "Footer-module--placeHolderShimmer--e8195";